export const firebaseConfig = {
  apiKey: "AIzaSyD9_KWdrv3wzAHmxLCKm26QnqrU-zP53jM",
  authDomain: "gestaoparceiros-72b6a.firebaseapp.com",
  projectId: "gestaoparceiros-72b6a",
  storageBucket: "gestaoparceiros-72b6a.firebasestorage.app",
  messagingSenderId: "93561157147",
  appId: "1:93561157147:web:a416dadd47457ae5bbeabe"
};